import React, { Component } from 'react';
import RichTextEditor from 'react-rte';

export default class MakeMail extends Component {
  state = {
    value: RichTextEditor.createEmptyValue()
  }

  onChange = (value) => {
    this.setState({value});
  };

  handleClick = () => {
    const subject = this.subject.value || "Bal 8 Twarzy Izetu - mailing";
    const type = this.tag.value || "mail-bez-tagu";
    this.props.onSubmit(this.state.value.toString('html'), subject, type);
  }

  render() {
    const { isSending, ids } = this.props;
    return (
      <div className="cc-mail-wrapper">
        <p>Mail zostanie wysłany do: <strong>{ids.length}</strong> osób</p>
        <p className="cc-mail-input-wrapper">
          <label>Tytuł maila</label>
          <input type="text" name="subject" ref={n=>this.subject = n} required/>
        </p>
        <p className="cc-mail-input-wrapper">
          <label>Tag do bazy</label>
          <input type="text" name="type" ref={n=>this.tag = n} required />
        </p>
        <RichTextEditor
          value={this.state.value}
          onChange={this.onChange}
        />
        <button className="btn" onClick={this.handleClick} disabled={isSending} >Wyślij</button>
        <p>Tips/info:</p>
        <ul>
          <li>{`Tytuł maila - wiadomo, tag - po taką nazwą będzie widoczny na liście obok użytkownika`}</li>
          <li><b>Można używać między innymi takich zmiennych w tekście:</b></li>
          <li>{`{{index}} - index studenta (w przypadku wysyłania do osób bez indesku nastąpi błąd)`}</li>
          <li>{`{{firstName}} - imię studenta`}</li>
          <li>{`{{surname}} - nazwisko studenta`}</li>
          {/* <li>{`{{phoneNumber}} - numer studenta`}</li> */}
          {/* <li>{`{{department}} - wydział (jak są z innego wydziału będzie 0)`}</li> */}
          {/* <li>{`{{tShirtSize}} - rozmiar koszulki`}</li> */}
          <li>{`{{statusStudent}} - status w bazie (np. zapisany, zakwalifikowany)`}</li>
          <li>{`{{paymentsInfo}} - status w bazie (np. zapłacone, niezapłacone)`}</li>
          {/* <li>{``}</li>
          <li>{``}</li>
          <li>{``}</li>
          <li>{``}</li> */}

          {/* <li>{`{{paymentsInfo}} - informacje o płatności`}</li> */}
          {/* <li>{`{{transport}} - pref. godz. wyjazu`}</li> */}
          <li><b>I jeszcze kilka jak coś trzeba pytajcie.</b></li>
        </ul>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/Admin/components/MakeMail.js